export const Header = ({ active, total }) => (
  <header className="header pres-header" data-testid="site-header">
    <div className="header-left">
      <span className="chapter pres-header-chapter" data-testid="header-chapter">
        <span className="chapter-slug">.cannes</span>
        <span className="chapter-em">—</span>
        <span className="chapter-label">09 · 09 · 2026</span>
      </span>
    </div>
    <div className="header-center">
      <a href="#cover" className="header-wordmark wordmark" data-testid="header-wordmark">SUNREEF</a>
    </div>
    <div className="header-right">
      <span className="slide-counter" data-testid="header-slide-counter">
        {String(active + 1).padStart(2, "0")} <span className="slide-counter-sep">/</span> {String(total).padStart(2, "0")}
      </span>
    </div>
  </header>
);

export default Header;
